// // *******************************************************************************
// // Reset Password form validation
// // *******************************************************************************
document.addEventListener('DOMContentLoaded', async () => {
  const resetPasswordForm = document.getElementById('reset-password-form');

  if (resetPasswordForm) {
    const formAction = resetPasswordForm.querySelector('input#reset_password_action').value;
    const nonce = await getNonceForAction(formAction);
    const fv = FormValidation.formValidation(resetPasswordForm, {
      locale: 'sl_SI',
      localization: FormValidation.locales.sl_SI,
      fields: {
        resetPassword: {
          validators: {
            regexp: {
              regexp: /(?=.{8,})/g,
            },
          },
        },
        confirmResetPassword: {
          validators: {
            identical: {
              compare() {
                return resetPasswordForm.querySelector('[name="resetPassword"]').value;
              },
            },
          },
        },
      },
      plugins: {
        message: new FormValidation.plugins.Message({
          container: (field, element) => element.closest('.mod-input,.checkbox'),
        }),
        declarative: new FormValidation.plugins.Declarative({
          html5Input: true,
        }),
        trigger: new FormValidation.plugins.Trigger(),
        submitButton: new FormValidation.plugins.SubmitButton(),
      },
    })

      .on('core.element.validated', (e) => {
        // e.element presents the field element
        // e.valid indicates the field is valid or not

        // Get the field value
        const value = fv.getElementValue(e.field, e.element);
        const container = FormValidation.utils.closest(e.element, '.mod-input,.checkbox');
        FormValidation.utils.classSet(container, {
          'is-validation-failed': value === '' || !e.valid,
        });
      })

      .on('core.form.valid', () => {
        const formData = {};
        resetPasswordForm.querySelectorAll('input, textarea').forEach((input) => {
          formData[input.name] = input.value.trim();
        });
        grecaptcha.ready(() => {
          grecaptcha.execute(localData.captchaSiteKey, { action: formData.reset_password_action }).then((token) => {
            const formErrorMessage = resetPasswordForm.querySelector('.form-error-message');
            formErrorMessage.classList.remove('is-validation-failed');
            const formDataImage = new FormData();
            formDataImage.append('action', formData.reset_password_action);
            formDataImage.append('inputs', JSON.stringify(formData));
            formDataImage.append('lang', localData.lang);
            formDataImage.append('id', localData.id);
            formDataImage.append('token', token);
            formDataImage.append('nonce', nonce);
            axios
              .post(localData.apiURL, formDataImage, {
                headers: {
                  'Content-Type': 'multipart/form-data',
                },
              })
              .then((response) => {
                if (response.status === 200) {
                  resetPasswordForm.innerHTML = response.data.data.msg;
                }
              })
              .catch((error) => {
                console.error(error.response.data.data.msg);
                formErrorMessage.innerHTML = `<div>${error.response.data.data.msg}</div>`;
                formErrorMessage.scrollIntoView({ behavior: 'smooth', block: 'center' });
                formErrorMessage.classList.add('is-validation-failed');
              });
          });
        });
      });
  }
});
